var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"we-picture-button"},[_c('we-rounded-picture',{attrs:{"picture":_vm.picture,"direction":_vm.direction,"name":_vm.name,"size":"32"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }